module.exports = __webpack_public_path__ + "static/media/img-notfound.3b69ca82.png";